// TODO: Refactor Cashier into `store`
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PromoLabelEnum, StorePromo } from "@saas/promotion/utils";
import { Money } from "@saas/shared/utils";

import { getRoundedTotal } from "../..";
import { CartItemInterface } from "../../@interface/cashier/cart-item/cart-item.interface";

export type GetCashierPricingInput = {
  promos?: ReadonlyArray<StorePromo>;
  items: ReadonlyArray<CartItemInterface>;
  hasRoundingUp?: boolean;
  hasPayment?: boolean;
};

export type GetCashierPricingOutput = {
  originalPrice: Money;
  discountPrice: Money;
  totalPrice: Money;
  roundedUpAmount?: Money;
};

export const getCashierPricing = ({
  items,
  promos = [],
  hasRoundingUp = false,
  hasPayment = false,
}: GetCashierPricingInput): GetCashierPricingOutput => {
  const totalProductPrice = items.reduce((total, data) => {
    return total.add(
      new Money(data.discountedPrice ?? data.price).times(data.quantity)
    );
  }, new Money(0));

  const totalPromosValue = promos.reduce((result, current) => {
    if (!hasPayment && current.label.value === PromoLabelEnum.PAYMENT_METHOD) {
      return result;
    }

    return result.add(current.grantedReward?.amount ?? 0);
  }, new Money(0));

  const totalDiscountPrice = totalProductPrice.subtract(totalPromosValue);

  const totalPriceWithoutRounding = totalDiscountPrice;

  const { total: totalPrice, roundedDifference: roundedUpAmount } =
    getRoundedTotal({
      total: totalPriceWithoutRounding.integer,
      isRounded: hasRoundingUp,
    });

  return {
    originalPrice: totalProductPrice,
    discountPrice: totalPrice.isPositive ? totalPrice : new Money(0),
    totalPrice: totalPrice.isPositive ? totalPrice : new Money(0),
    roundedUpAmount: new Money(roundedUpAmount),
  };
};

export default getCashierPricing;
